import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AdminLayout } from "../shared/layout";
import { addRole, getPermissions } from "../../../data";

import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CardBox } from "../shared/CardBox";

export function RoleAddScreen() {
  const queryClient = useQueryClient();
  const pageSettings = {
    title: "Rol Oluştur",
    actions: [
      {
        name: "Listeye Dön",
        color: "blue",
        icon: "add-icon",
        onClick: () => {
          navigate("/admin/roles");
        },
      },
    ],
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["permissions"],
    queryFn: getPermissions,
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const mutation = useMutation({
    mutationKey: ["createRole"],
    mutationFn: (data) => {
      return addRole(data);
    },
    onSuccess: (response) => {
      navigate("/admin/roles");
    },
  });
  const onSubmit = async (data) => {
    const { name, permissions } = data;

    console.log("permissions", permissions);
    mutation.mutate({ name, permissions });
  };

  return (
    <AdminLayout title={pageSettings.title} actions={pageSettings.actions}>
      <CardBox title="Rol Oluştur" description="Yeni bir rol oluştur">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              className="block text-foreground text-sm font-bold mb-2"
              htmlFor="name"
            >
              Ad
            </label>

            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-foreground bg-background leading-tight focus:outline-none focus:shadow-outline"
              id="name"
              type="text"
              placeholder="name"
              {...register("name", {
                required: "Ad zorunludur",
              })}
            />
            {errors.name && <p>{errors.name.message}</p>}
          </div>
          {/* create multi select for permissions */}

          {!isLoading && (() => {
            // Group permissions by prefix (e.g., USER_CREATE -> USER)
            const groupedPermissions = data.data.reduce((acc, permission) => {
              const parts = permission.name.split('_');
              const group = parts.length > 1 ? parts[0] : 'OTHER';
              if (!acc[group]) {
                acc[group] = [];
              }
              acc[group].push(permission);
              return acc;
            }, {});

            return (
              <div className="mb-4">
                <label
                  className="block text-foreground text-sm font-bold mb-2"
                  htmlFor="permissions"
                >
                  Yetkiler
                </label>
                <div className="space-y-4">
                  {Object.entries(groupedPermissions).map(([groupName, permissions]) => (
                    <div key={groupName} className="border rounded-lg p-4 bg-muted">
                      <h4 className="font-semibold text-foreground mb-3 border-b pb-2">
                        {groupName}
                      </h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                        {permissions.map((permission) => (
                          <div key={permission.id} className="flex items-center">
                            <input
                              type="checkbox"
                              id={`permission-${permission.id}`}
                              value={permission.id}
                              className="mr-2 leading-tight focus:outline-none focus:shadow-outline"
                              {...register("permissions")}
                            />
                            <label
                              htmlFor={`permission-${permission.id}`}
                              className="text-sm text-foreground cursor-pointer"
                            >
                              {permission.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                {errors.permissions && (
                  <p className="text-red-500 text-xs italic mt-2">
                    {errors.permissions.message}
                  </p>
                )}
              </div>
            );
          })()}
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Rol Oluştur
            </button>
          </div>
        </form>
      </CardBox>
    </AdminLayout>
  );
}
